import { render } from "./ShouKuan.vue?vue&type=template&id=859130e0&scoped=true"
import script from "./ShouKuan.vue?vue&type=script&lang=js"
export * from "./ShouKuan.vue?vue&type=script&lang=js"

import "./ShouKuan.vue?vue&type=style&index=0&id=859130e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859130e0"]])

export default __exports__